exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".payment-profiles .profile-wrap[data-v-18577c5a] {\n  margin: 1.2em 0em;\n}\n", ""]);

// exports
